import { useCheckNeedSetupModuleSettings } from "@/modules/global-wizard/features/setup-module-settings/model/use-check-need-setup-module-settings";
import { ReactNode, useState } from "react";
import { Modal } from "@/shared/modal";
import { Welcome } from "@/modules/global-wizard/features/setup-module-settings/ui/welcome";
import { useModuleInfo } from "@/modules/global-wizard/features/setup-module-settings/model/use-module-info";
import { SaveHrSettings } from "@/modules/global-wizard/features/save-hr-settings";
import { useGlobalWizard } from "@/modules/global-wizard/features/setup-module-settings/model/use-global-wizard";
import { ModuleInitialiseStep } from "gql/graphql";
import { useTranslations } from "use-intl";

export function SetupModuleSettings({ children }: { children: ReactNode }) {
  const t = useTranslations("GlobalWizard");
  const { loading, isNeedSetup } = useCheckNeedSetupModuleSettings();
  const [wantToSetup, setWantToSetup] = useState<boolean | undefined>(
    undefined,
  );
  const { modulesInfo } = useModuleInfo({ wantToSetup });
  const { step } = useGlobalWizard({
    modules: modulesInfo,
  });

  if (loading) {
    return null;
  }

  return (
    <>
      <Modal
        open={isNeedSetup && wantToSetup === undefined}
        title={t("Modules setup wizard")}
        onCancel={() => setWantToSetup(false)}
      >
        <Welcome getChoice={setWantToSetup} />
      </Modal>

      <Modal
        open={isNeedSetup && wantToSetup && step !== undefined}
        title={t("Modules setup wizard")}
        onCancel={() => setWantToSetup(false)}
      >
        {step === ModuleInitialiseStep.HrHrSettings && <SaveHrSettings />}
      </Modal>

      {children}
    </>
  );
}
